<script lang="ts">
import { useRouter } from "vue-router";
import { MainTopic } from "@/interface/MainTopic.interface";
import { complaintService, fileService, userService } from "@/services/serviceProvider";
import { LANG_EN } from "@/app/const";
import { useSharedDataStore } from "@/store/app";
import { SubTopic } from "@/interface/SubTopic.interface";
import { ref } from "vue";
import { UrlResponse } from "@/interface/FileUpload.interface";
import airline from '@/assets/images/home/home-img-1.png';
import search from '@/assets/images/home/home-img-6.png';
import PreComplaint from "../complaint/preComplaint.vue";

export default {
  setup() {
    const router = useRouter();
    const store = useSharedDataStore();
    const preComplaint = ref();

    return {
      router,
      store,
      preComplaint
    };
  },
  components: { PreComplaint },
  data() {
    return {
      allTopics: [] as MainTopic[],
      mainTopics: [] as MainTopic[],
      top3Topics: [] as SubTopic[],
      other: {
        topicTh: 'แจ้งเรื่องร้องเรียน',
        topicEn: 'Complaint',
        descriptionTh: 'เรื่องร้องเรียนอื่นๆ',
        descriptionEn: 'Other Complaint',
        imageUrl: search
      } as MainTopic,
      mainTopicSelectedId: undefined as number | undefined,
      subTopicSelectedId: undefined as number | undefined,
      lang: this.$i18n.locale,
      en: LANG_EN
    };
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      this.lang = newVal;
    },
  },
  async mounted() {
    await this.onLoad();
    await this.loadMainTopics();
    await this.loadTop3Topics();
    this.store.setMyData({ reloadDoc: false });
  },
  computed: {
  },
  methods: {
    async onLoad() {
      if (userService.isUser() || userService.isAsc()) {
        await this.loadData();
      } else {
        this.router.push({
          path: `/complaint-list`
        })
      }
    },
    async loadData() {
      try {
        let response = await complaintService.getAllComplaintTopics();
        if (response) {
          this.allTopics = response.data as MainTopic[];
        }
      } catch (e) {
        throw e;
      }
    },
    async loadMainTopics() {
      let main = [...this.allTopics] as MainTopic[];
      main = main.slice(0, 4);
      let allMainImages = main.filter(o => o.imageUrl).map(m => ({ objectName: m.imageUrl }));
      try {
        let res = await fileService.getUrl(allMainImages);
        if (res && res.status === 201) {
          let dataUrl = res.data as UrlResponse;
          for (const o of main.filter(o => o.imageUrl)) {
            o.imageUrl = dataUrl.urls.find(url => url.objectName === o.imageUrl)?.url ?? airline;
          }
        }
      } catch (e) {
        for (const o of main.filter(o => o.imageUrl)) {
          o.imageUrl = airline;
        }
      }
      for (const o of main.filter(o => !o.imageUrl)) {
        o.imageUrl = airline;
      }
      this.mainTopics = [...main];
    },
    onMainTopicSelected(item: any) {
      if (this.mainTopicSelectedId === item.id) {
        this.subTopicSelectedId = undefined;
        if (this.preComplaint) this.preComplaint.displaySubTopicDialog(true);
      }
      this.mainTopicSelectedId = item.id;
    },
    async loadTop3Topics() {
      let allSubs = [] as SubTopic[];
      this.allTopics.forEach(o => {
        o.subTopics = o.subTopics?.map(s => ({
          ...s,
          mainId: o.id
        }))
      })
      this.allTopics.map(o => o.subTopics).forEach(subs => {
        if (subs && subs.length > 0) {
          allSubs = allSubs.concat(subs)
        }
      });
      let top3 = allSubs && allSubs.length > 0 ? allSubs.sort((a, b) => b.ratingNumber - a.ratingNumber).slice(0, 3) : [];
      if (top3) {
        let allTop3Images = top3.filter(o => o.imageUrl).map(m => ({ objectName: m.imageUrl }));
        try {
          let res = await fileService.getUrl(allTop3Images);
          if (res && res.status === 201) {
            let dataUrl = res.data as UrlResponse;
            for (const o of top3.filter(o => o.imageUrl)) {
              o.imageUrl = dataUrl.urls.find(url => url.objectName === o.imageUrl)?.url ?? airline;
            }
          }
        } catch (e) {
          for (const o of top3.filter(o => o.imageUrl)) {
            o.imageUrl = airline;
          }
        }
        for (const o of top3.filter(o => !o.imageUrl)) {
          o.imageUrl = airline;
        }
        this.top3Topics = [...top3];
      } else {
        this.top3Topics = [];
      }
    },
    onPopularSelected(mainId: number, subId: number) {
      if (this.mainTopicSelectedId === mainId && this.subTopicSelectedId === subId) {
        if (this.preComplaint) this.preComplaint.displaySubTopicDialog(true);
      }
      this.mainTopicSelectedId = mainId;
      this.subTopicSelectedId = subId;
    },
    async goToAllComplaint() {
      this.router.push({ path: `/complaint` });
    },
    topicName(item: any) {
      return this.lang === LANG_EN ? item.topicEn : item.topicTh;
    },
    topicNameReverse(item: any) {
      return this.lang === LANG_EN ? item.topicTh : item.topicEn;
    },
    topicDesc(item: any) {
      return this.lang === LANG_EN ? item.descriptionEn : item.descriptionTh;
    },
  },
};
</script>
<template>
  <div v-if="mainTopics && mainTopics.length > 0" class="home-container mb-6">
    <v-row class="mb-2">
      <v-col v-for="sub in top3Topics" cols="4" lg="4">
        <v-hover v-slot="{ isHovering, props }">
          <v-card v-bind="props" :image="sub.imageUrl" class="home-complaint-card popular px-2 py-3 h-100"
            @click="onPopularSelected(sub.mainId, sub.id)">
            <v-row>
              <v-col cols="12" class="d-flex flex-column align-space-between pb-6">
                <v-card-title class="pb-0">
                  <span v-if="lang !== en">{{ $t("t-complaint-about") }}</span>
                  <span>{{ topicName(sub) }}</span>
                </v-card-title>
                <!-- <v-card-text>
                  {{ topicNameReverse(sub) }}
                </v-card-text> -->
              </v-col>
            </v-row>
            <v-overlay persistent :model-value="!!isHovering" class="align-center justify-center" scrim="#036358" contained>
            </v-overlay>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-card-title class="pl-0 mb-2">{{ $t('t-complaint-lbl-topic-other') }}</v-card-title>
    <v-row class="mb-1">
      <v-col cols="12" class="mb-4">
        <v-row style="height: fit-content;" class="px-2">
          <v-col v-for="(main, index) in mainTopics" cols="12" sm="6" lg="3">
            <v-card class="home-complaint-card normal px-2 py-3 h-100" :image="main.imageUrl"
              :class="index > 4 ? 'darker' : ''">
              <div class="h-100 d-flex flex-column align-space-between">
                <v-card-title class="pb-1">
                  {{ topicName(main) }}
                </v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text class="py-2">
                  {{ topicDesc(main) }}
                </v-card-text>
                <v-card-actions class="px-4 w-100">
                  <v-btn @click="onMainTopicSelected(main)" block>
                    {{ $t("t-complaint-this-topic") }}
                  </v-btn>
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row v-if="other" style="height: fit-content;" class="px-2">
          <v-col cols="12">
            <v-card class="home-complaint-card other px-2 py-3 h-100 darker" :image="other.imageUrl">
              <div class="h-100 d-flex flex-column align-space-between">
                <v-card-title class="pb-1">
                  {{ topicName(other) }}
                </v-card-title>
                <v-divider class="mx-4" style="width: 30%;"></v-divider>
                <v-card-text class="py-2 mb-3">
                  {{ topicDesc(other) }}
                </v-card-text>
                <v-card-actions class="px-4 w-100">
                  <v-btn @click="goToAllComplaint" block>
                    {{ $t('t-complaint-page-right-other') }}
                  </v-btn>
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
  <PreComplaint ref="preComplaint" :main-topic-id="mainTopicSelectedId" :sub-topic-id="subTopicSelectedId">
  </PreComplaint>
</template>
